define('view/block/tabs.container.view',['require','exports','module','fukit'],function(require, exports, module) {
  var TabsContainerView = require('fukit').TabsContainerView;

  TabsContainerView.extend({
    // The FuKit parent view class' attributes are not needed in COI
    attributes: {},
  });
  module.exports = TabsContainerView;
});

